module.exports = __webpack_public_path__ + "static/media/chat.5435ad70.webp";